/**
 * KAN-743: ссылки и картинки из фида товаров - недоверенные данные.
 * В href/src пускаем только абсолютные http(s) URL; javascript:, data: и прочее
 * отбрасываем (backend тоже чистит, это вторая линия защиты).
 */
const HTTP_URL = /^https?:\/\//i;

/** URL без пробелов по краям, если он http(s), иначе null. */
export function safeHttpUrl(value: string | null | undefined): string | null {
  if (typeof value !== 'string') return null;
  const url = value.trim();
  return HTTP_URL.test(url) ? url : null;
}
